/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerFindAllQueryResponse,
  TelegramProductsUserControllerFindAllQueryParams,
  TelegramProductsUserControllerFindAll401,
} from '../../types/TelegramProductsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserFindAll } from '../../methods/telegramProductsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserFindAllQueryKey = (params?: TelegramProductsUserControllerFindAllQueryParams) =>
  [{ url: '/api/user/telegram/products' }, ...(params ? [params] : [])] as const;

export type TelegramProductsUserFindAllQueryKey = ReturnType<typeof telegramProductsUserFindAllQueryKey>;

export function telegramProductsUserFindAllQueryOptions(
  params?: TelegramProductsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserFindAllQueryKey(params);
  return queryOptions<
    TelegramProductsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindAll401>,
    TelegramProductsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/products}
 */
export function useTelegramProductsUserFindAll<
  TData = TelegramProductsUserControllerFindAllQueryResponse,
  TQueryData = TelegramProductsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserFindAllQueryKey,
>(
  params?: TelegramProductsUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramProductsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsUserControllerFindAll401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
